import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import { useInstance } from 'intact-vue';
import { isUndefined } from 'intact-shared';
export function useStep(defaultStep) {
  var instance = useInstance();
  var step = function step() {
    var _instance$get = instance.get(),
      step = _instance$get.step,
      min = _instance$get.min;
    return [step, min];
  };
  instance.on('$receive:step', function (v) {
    var getStep = parseStep(v, defaultStep);
    step = function step(value, direction) {
      var step = getStep(value, direction);
      var min = instance.get('min');
      if (Array.isArray(step)) {
        return [step[0], isUndefined(step[1]) ? min : Math.max(min, step[1])];
      } else {
        return [step, min];
      }
    };
  });
  return function (value, direction) {
    return step(value, direction);
  };
}
function parseStep(step, defaultValue) {
  var _context, _context2;
  var type = typeof step;
  switch (type) {
    case 'number':
      return function () {
        return step;
      };
    case 'object':
      var breakpoints = _sortInstanceProperty(_context = _mapInstanceProperty(_context2 = _Object$keys(step)).call(_context2, function (i) {
        if (i === '$') {
          return {
            key: i,
            value: Number.POSITIVE_INFINITY
          };
        }
        return {
          key: i,
          value: Number(i)
        };
      })).call(_context, function (a, b) {
        return a.value - b.value;
      });
      return function (value, direction) {
        for (var i = 0; i < breakpoints.length; i++) {
          var breakpoint = breakpoints[i];
          var prevBreakpoint = breakpoints[i - 1];
          if (value < breakpoint.value) {
            return [step[breakpoint.key], prevBreakpoint && prevBreakpoint.value];
          }
          if (value === breakpoint.value) {
            // we must detect the direction when it is a breakpoint
            if (direction === 'increase') {
              var nextBreakpoint = breakpoints[i + 1];
              if (nextBreakpoint !== undefined) {
                return [step[nextBreakpoint.key], breakpoint.value];
              }
            }
            return [step[breakpoint.key], prevBreakpoint && prevBreakpoint.value];
          }
        }
        return [defaultValue, undefined];
      };
    case 'function':
      return step;
    default:
      return function () {
        return defaultValue;
      };
  }
}